import {createContext, useContext} from 'react'

export const HasLocaleErrorContext = createContext(undefined)

export const useHasLocaleError = () => {
    const context = useContext(HasLocaleErrorContext)

    return context
}
